<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-list-links-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalListLinks"
    ></button>
    <div
      class="modal fade"
      id="modalListLinks"
      tabindex="-1"
      aria-labelledby="modalListLinksLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalListLinksLabel">
              {{ modalTitle }}
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons justify-content-end btn-close-modal-list-links"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div v-if="physicalBraches.length > 0">
              <div
                v-for="(physicalBranch, index) in physicalBraches"
                :key="index"
              >
                <div
                  class="d-flex align-items-center justify-content-between pt-2 pb-2"
                  style="border-bottom: 1px solid #ddd"
                >
                  <div class="text-bold" style="color: #000">
                    {{ physicalBranch.name }}
                  </div>
                  <div v-if="linkType == 1" class="d-flex">
                    <div
                      v-if="physicalBranch.link_stock_transfer != ''"
                      class="tag-a-custom"
                      @click="viewLink(physicalBranch.link_stock_transfer)"
                    >
                      Stock Transfer
                    </div>
                    <div
                      v-if="physicalBranch.link != ''"
                      class="tag-a-custom ms-3"
                      @click="viewLink(physicalBranch.link)"
                    >
                      Item On/Off
                    </div>
                  </div>
                  <div v-else-if="linkType == 2">
                    <div
                      v-if="physicalBranch.link != ''"
                      class="tag-a-custom"
                      @click="viewLink(physicalBranch.link + '?type=2')"
                    >
                      View
                    </div>
                  </div>
                </div>
                <div
                  v-if="linkType == 3 && physicalBranch.printers && physicalBranch.printers.length > 0"
                >
                  <div
                    v-for="printer in sortPrinters(physicalBranch.printers)"
                    :key="printer.id"
                    class="d-flex align-items-center justify-content-between pt-2 pb-2"
                    style="border-bottom: 1px solid #ddd"
                  >
                    <div class="ps-5">{{ printer.name }}</div>
                    <div class="d-flex">
                      <div
                        class="tag-a-custom"
                        @click="viewLink(printer.link_preparing)"
                      >
                        Preparing
                      </div>
                      <div
                        class="tag-a-custom ms-3"
                        @click="viewLink(printer.link_ready)"
                      >
                        Ready
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="linkType != 3 && physicalBranch.branches.length > 0">
                  <div
                    v-for="(branch, index2) in physicalBranch.branches"
                    :key="index2"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between pt-2 pb-2"
                      style="border-bottom: 1px solid #ddd"
                    >
                      <div class="ps-5">
                        {{ branch.branch_name }}
                      </div>
                      <div v-if="linkType == 2" class="tag-a-custom" @click="viewLink(branch.link)">
                        View
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-close-modal btn-sm"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-success btn-background btn-sm"
              @click="searchMember"
            >
              Search
            </button>
          </div>
          <MaterialLoading :active="loaderActive" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardService from "@/services/dashboard.service";
import MaterialLoading from "@/components/MaterialLoading.vue";

export default {
  name: "ModalSearchMember",
  components: {
    MaterialLoading,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    linkType: {
      type: Number,
      default: 1, // 1: Stock Link, 2: Order Link, 3: KDS Links
    },
  },
  data() {
    return {
      physicalBraches: [],
      loaderActive: false,
    };
  },
  computed: {
    modalTitle() {
      if (this.linkType == 1) return "Item On/Off";
      if (this.linkType == 3) return "KDS Links";
      return "Order Status Links";
    },
  },
  methods: {
    getListLinks() {
      this.loaderActive = true;
      DashboardService.getListLinks({
        type: this.linkType,
      })
        .then((response) => {
          if (response.data.result.isSuccess) {
            this.physicalBraches = response.data.data;
            this.loaderActive = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loaderActive = false;
        });
    },

    // M1016: "Not Printable" routes nothing to the kitchen, so it goes last
    // under each branch; the rest keep API order.
    sortPrinters(printers) {
      const isNotPrintable = (printer) =>
        (printer.name ?? "").trim().toLowerCase() === "not printable";
      return [...printers].sort(
        (a, b) => isNotPrintable(a) - isNotPrintable(b)
      );
    },

    viewLink(link) {
      window.open(link, "_blank");
    },
  },
  watch: {
    keyReload: {
      handler() {
        this.physicalBraches = [];
        this.getListLinks();
      },
    },
  },
};
</script>

<style scoped>
.modal-body {
  min-height: 50vh;
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}
</style>
